import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './Investor_KYC_AML_Check_S.css';

const Investor_KYC_AML_Check_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Investor KYC AML Check');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_KYC_AML_CHECK/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/Investor_KYC_AML_Check', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_${i}_SECTION`;
	  const headerId = `#PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_KYC_AML_CHECK/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/Investor_KYC_AML_Check',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [INVESTOR_KYC_AML_CHECK, setINVESTOR_KYC_AML_CHECK] = React.useState(null);
  const [INVESTOR_KYC_AML_CHECK_S, setINVESTOR_KYC_AML_CHECK_S] = React.useState(null);

  var Ids = [];
  for(var Ele in INVESTOR_KYC_AML_CHECK_S){
	  for(var Sec in INVESTOR_KYC_AML_CHECK_S[Ele]){
			if(Sec == "id")
				Ids.push(INVESTOR_KYC_AML_CHECK_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(INVESTOR_KYC_AML_CHECK_S[Ele]["status"]);
			else if(Array.isArray(INVESTOR_KYC_AML_CHECK_S[Ele][Sec]))
				  for(var Row in INVESTOR_KYC_AML_CHECK_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in INVESTOR_KYC_AML_CHECK_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_KYC_AML_CHECK`).then((response) => {
      setINVESTOR_KYC_AML_CHECK(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setINVESTOR_KYC_AML_CHECK_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!INVESTOR_KYC_AML_CHECK_S) return <div>Loading...</div>;

 const handleLastDataINVESTOR_KYC_AML_CHECK_S = async (data) => {
  };




  const handleAddINVESTOR_KYC_AML_CHECK_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_KYC_AML_CHECK_S', JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/INVESTOR_KYC_AML_CHECK_S');
      setINVESTOR_KYC_AML_CHECK_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["1"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("1","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["2"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2"]=value;
	Form_Data_onChange("2","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  


const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["3"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3"]=value;
	Form_Data_onChange("3","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  

  
      
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["4"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0"]=value ? true : false; // optionally just use boolean
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("4","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  


    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["4"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("4","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  

const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0"]=value;
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK(Temp_Data);
    setINVESTOR_KYC_AML_CHECK(Temp_Data);
	//handleAddINVESTOR_KYC_AML_CHECK(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK']);
  }; 
  

    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  
    
const PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(INVESTOR_KYC_AML_CHECK_S));
	Temp_Data["9"]["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4"]=value;
	//handleAddINVESTOR_KYC_AML_CHECK_S(Temp_Data,App_Data['INVESTOR_KYC_AML_CHECK_S']);
	Form_Data_onChange("9","PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4",value,Temp_Data);
 	//handleLastDataINVESTOR_KYC_AML_CHECK_S(Temp_Data);
    setINVESTOR_KYC_AML_CHECK_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = INVESTOR_KYC_AML_CHECK_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Investor KYC AML Check')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`KYC AML Check ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0" type="text" className="form-control" placeholder="KYC AML Check ID"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter KYC AML Check ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Investor ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1" type="text" className="form-control" placeholder="Investor ID"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Investor ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`KYC Provider`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2" type="text" className="form-control" placeholder="KYC Provider"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter KYC Provider`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '120ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Provider Reference ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3" type="text" className="form-control" placeholder="Provider Reference ID"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '120ch' }}>
						 {t(`Enter Provider Reference ID`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Identity Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0_Change} className="form-control" name="Identity Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Matched">Matched</option>
						  <option value="Mismatch">Mismatch</option>
						  <option value="Failed">Failed</option>
						  <option value="Manual Review">Manual Review</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Identity Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Address Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1_Change} className="form-control" name="Address Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Verified">Verified</option>
						  <option value="Failed">Failed</option>
						  <option value="Manual Review">Manual Review</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Address Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Document Type`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2_Change} className="form-control" name="Document Type"  >
						  <option value="Driver License">Driver License</option>
						  <option value="State ID">State ID</option>
						  <option value="Passport">Passport</option>
						  <option value="Permanent Resident Card">Permanent Resident Card</option>
						  <option value="Entity Document">Entity Document</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Document Type
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`KYC Result`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0_Change} className="form-control" name="KYC Result"  >
						  <option value="Pass">Pass</option>
						  <option value="Fail">Fail</option>
						  <option value="Manual Review">Manual Review</option>
						  <option value="Expired">Expired</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter KYC Result
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Sanctions Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1_Change} className="form-control" name="Sanctions Status"  >
						  <option value="Not Checked">Not Checked</option>
						  <option value="Clear">Clear</option>
						  <option value="Potential Match">Potential Match</option>
						  <option value="Confirmed Match">Confirmed Match</option>
						  <option value="Manual Review">Manual Review</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Sanctions Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`PEP Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2_Change} className="form-control" name="PEP Status"  >
						  <option value="Not Checked">Not Checked</option>
						  <option value="Clear">Clear</option>
						  <option value="Potential PEP">Potential PEP</option>
						  <option value="Confirmed PEP">Confirmed PEP</option>
						  <option value="Manual Review">Manual Review</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter PEP Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`AML Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3_Change} className="form-control" name="AML Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Pending">Pending</option>
						  <option value="Passed">Passed</option>
						  <option value="Failed">Failed</option>
						  <option value="Manual Review">Manual Review</option>
						  <option value="Prohibited">Prohibited</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter AML Status
				     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Manual Review Required`)} <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0" type="checkbox" style={{ marginLeft: '5px' }}  onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0_Change} 
					  checked={INVESTOR_KYC_AML_CHECK_S?.["4"]?.["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0"] === "true" || INVESTOR_KYC_AML_CHECK_S?.["4"]?.["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0"] === true} />
					</label>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '3000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Manual Review Notes`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1" type="text" className="form-control" placeholder="Manual Review Notes"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '3000ch' }}>
						 {t(`Enter Manual Review Notes`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0"   onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`KYC AML Check ID`)}</th>
                        <th>{t(`Investor ID`)}</th>
                        <th>{t(`KYC Provider`)}</th>
                        <th>{t(`Provider Reference ID`)}</th>
                        <th>{t(`Identity Status`)}</th>
                        <th>{t(`Address Status`)}</th>
                        <th>{t(`Document Type`)}</th>
                        <th>{t(`KYC Result`)}</th>
                        <th>{t(`Sanctions Status`)}</th>
                        <th>{t(`PEP Status`)}</th>
                        <th>{t(`AML Status`)}</th>
                        <th>{t(`Manual Review Required`)}</th>
                        <th>{t(`Manual Review Notes`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {INVESTOR_KYC_AML_CHECK_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_0"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_1"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_2"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_1_3"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_0"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_1"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_2_2"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_0"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_1"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_2"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_3_3"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_0"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_4_1"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_0"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_1"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_2"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_3"]} </td>
						<td>{e["PLATFORM_CORE_03_INVESTOR_ONBOARDING_COMPLIANCE_INVESTOR_KYC_AML_CHECK_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default Investor_KYC_AML_Check_S;  